import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateCustomFieldValuesForCustomerMutation as _UpdateCustomFieldValuesForCustomerMutation,
  UpdateCustomFieldValuesForCustomerInput,
} from '@/gql/graphql';

const UpdateCustomFieldValuesForCustomerMutation = graphql(`
  mutation UpdateCustomFieldValuesForCustomer(
    $input: UpdateCustomFieldValuesForCustomerInput!
  ) {
    updateCustomFieldValuesForCustomer(input: $input) {
      customFields {
        field {
          identifier
          isRequired
          label
          type
          options
          schema
        }
        value
      }
    }
  }
`);

const useUpdateCustomFieldValuesForCustomer = (
  options?: UseMutationOptions<
    _UpdateCustomFieldValuesForCustomerMutation,
    unknown,
    UpdateCustomFieldValuesForCustomerInput
  >
) => {
  return useMutation({
    mutationFn: (variables) => {
      return gqlClient.request(UpdateCustomFieldValuesForCustomerMutation, {
        input: variables,
      });
    },
    ...options,
  });
};

export default useUpdateCustomFieldValuesForCustomer;
